module.exports = __webpack_public_path__ + "img/partnerzy-01_ongeo_services.ffbb6baa.svg";